import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { ApplicationViewService } from '@features/application-view/application-view.service';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { InKindService } from '../in-kind.service';
import { InKindRequestedItem } from '../in-kind.typing';

@Component({
  selector: 'gc-in-kind-items-popover',
  templateUrl: './in-kind-items-popover.component.html',
  styleUrls: ['./in-kind-items-popover.component.scss']
})
export class InKindItemsPopoverComponent implements OnChanges {
  @Input() applicationId: number;
  @Input() inKindItems: InKindRequestedItem[];
  @Input() inKindItemTotalCount: number;
  @Input() amount: string|number;
  @Input() amountIsBold = false;
  @Input() popoverPlacement: 'right'|'left' = 'left';
  @Input() unitsOnNewLine = false;
  @Input() alignRight = false;

  allItemsMap = this.inKindService.allItemsMap;
  defaultCurrency = this.clientSettingsService.defaultCurrency;
  isManager = this.portalDetermination.isManager;
  inKindItemsForDisplay: InKindRequestedItem[] = [];

  constructor (
    private inKindService: InKindService,
    private clientSettingsService: ClientSettingsService,
    private portalDetermination: PortalDeterminationService,
    private applicationViewService: ApplicationViewService
  ) { }

  ngOnChanges (changes: SimpleChanges) {
    if (changes.inKindItems && !!this.inKindItems) {
      this.inKindItemsForDisplay = this.inKindItems;
    }
  }

  async showPopover () {
    if (!this.inKindItems) {
      if (this.applicationId) {
        const detail = await this.applicationViewService.getApplicationDetail(
          this.applicationId
        );
        this.inKindItemsForDisplay = detail.inKindItems;
      }
    }
  }
}
